import React from 'react'
import { Box } from '@mui/material'
import { standardStateAtom, treeAtom } from './atoms'
import { GoogleLoginButton } from 'infrastructure/googleDrive'
import { useAtom, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { useGetTreeById } from 'shared/hooks/trees/hooks'
import StandardStateSelector from '../../utility/StandardStateSelector'
import { StandardsTable } from './StandardsTable'
import { UpdatesTable } from './UpdatesTable'
import { DataTable } from './DataTable'

export function UPStandards(ids: { treeId: string; versionId: string }) {
  const treeData = useGetTreeById(ids)
  useSetAtom(treeAtom)(treeData)
  return (
    <Box>
      <Box>UP Standards</Box>
      <Box>
        <GoogleLoginButton LoggedInComponent={UpdatesView} />
      </Box>
    </Box>
  )
}

function UpdatesView() {
  const [standardState, setStandardState] = useAtom(standardStateAtom)
  return (
    <Box>
      <StandardStateSelector
        currentSelection={standardState}
        handleChange={setStandardState}
      />
      <UpdatesTable />
      <DataTable />
      <StandardsTable />
    </Box>
  )
}
